<template>
	<div
		id="save-profile-modal"
		class="modal fade"
		tabindex="1"
		aria-labelledby="save-profile-modal"
		@keyup.esc.stop.prevent="Close()"
	>
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content p-4">
				<div class="flex items-start">
					<p class="mb-0">
						SELECIONE UMA DAS OPÇÕES A SEGUIR PARA SALVAR O SEU
						FILTRO ATUAL.
					</p>
					<div class="close-modal-container">
						<button
							id="close-modal"
							class="btn btn-light btn-sm btn-legacy"
							@click="Close()"
							tabindex="5"
						>
							<i class="fal fa-times"></i>
						</button>
					</div>
				</div>
				<div class="modal-body">
					<div class="w-full">
						<div class="btn-pills-group">
							<button
								id="profile_1"
								class="btn btn-pill"
								:class="{
									active: selectedProfile === 'profile_1',
								}"
								@click="SelectProfile('profile_1')"
								tabindex="2"
							>
								F1
							</button>
							<button
								id="profile_2"
								class="btn btn-pill"
								:class="{
									active: selectedProfile === 'profile_2',
								}"
								@click="SelectProfile('profile_2')"
								tabindex="3"
							>
								F2
							</button>
							<button
								id="profile_3"
								class="btn btn-pill"
								:class="{
									active: selectedProfile === 'profile_3',
								}"
								@click="SelectProfile('profile_3')"
								tabindex="4"
							>
								F3
							</button>
						</div>
					</div>
				</div>
				<div class="w-full flex justify-between">
					<button
						class="btn btn-danger btn-fixed-size"
						tabindex="6"
						@click="Close"
					>
						CANCELAR
					</button>
					<button
						class="btn btn-success btn-fixed-size"
						tabindex="5"
						@click="SaveProfile"
					>
						SALVAR
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { useInfo } from '@/composables'

	export default {
		name: 'SaveProfileModal',
		data() {
			return {
				selectedProfile: null,
			}
		},
		methods: {
			Open() {
				const modal = window.jQuery('#save-profile-modal')
				modal.modal({
					focus: false,
				})
				modal.modal('show')
			},
			Close() {
				window.jQuery('#save-profile-modal').modal('hide')
				window.jQuery('body').removeClass('modal-open')

				this.$emit('close')
			},
			SelectProfile(profile) {
				this.selectedProfile = profile
			},
			SaveProfile() {
				if (!this.selectedProfile) {
					useInfo('Selecione um perfil antes de tentar salvar!')
					return
				}

				this.$emit('save', this.selectedProfile)

				this.Close()
			},
		},
		async mounted() {
			this.Open()

			window.jQuery('#save-profile-modal').on('hidden.bs.modal', () => {
				window.jQuery('body').removeClass('modal-open')

				this.$emit('close')
			})

			await this.$nextTick()

			setTimeout(() => {
				document
					.querySelector('#save-profile-modal #close-modal')
					?.focus()
			}, 300)
		},
	}
</script>

<style lang="scss" scoped>
	.modal-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 1.5rem;
	}

	.btn {
		padding: 0.7rem 1rem;
		color: var(--white);
		outline: none;
		background-color: var(--newPrimaryBackgroundColor);
		border: 1px solid var(--newPrimaryBackgroundColor);
		border-radius: 0.3rem;
		transition: all 0.1s ease-in-out;
		height: unset;
		display: flex;
		align-items: center;
		justify-content: center;

		&.btn-success {
			background-color: var(--successBackgroundColor);
			border-color: var(--successBackgroundColor);

			&:hover {
				background-color: var(--successHoverBackgroundColor);
				border-color: var(--successHoverBackgroundColor);
			}
		}

		&.btn-danger {
			background-color: red;
			border-color: red;

			&:hover {
				background-color: #6f0202;
				border-color: #6f0202;
			}
		}

		&.btn-legacy {
			width: unset;
			height: unset;
			padding: 0.7rem 1rem;
			background-color: var(--backgroundLight);
			border: 1px solid var(--backgroundLight);
			color: var(--fontColor);

			&:hover {
				background-color: var(--backgroundLighter);
				border-color: var(--backgroundLighter);
			}
		}

		&.btn-fixed-size {
			width: 9.3rem;
			height: 3.361rem;
			min-height: unset;
			max-height: unset;
			padding: 0.25rem 1rem;
			font-size: 0.9rem;
		}
	}

	.btn-pills-group {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 0.2rem 0;
		gap: 0.1rem;

		.btn-pill {
			--pillRadius: 0.5rem;
			height: 3.361rem;
			width: 9.3rem;
			flex-grow: 1;
			border-radius: 0;
			font-size: 1rem;
			position: relative;
			background-color: var(--newPrimaryBackgroundColor);
			color: var(--fontColor);

			&:hover {
				background-color: var(--newPrimaryHoverBackgroundColor);
				border-color: var(--newPrimaryHoverBackgroundColor);
				color: var(--newPrimaryHoverColor);
			}

			&.active {
				background-color: var(--pendingActiveBackgroundColor);
				border-color: var(--pendingActiveBackgroundColor);
				color: var(--pendingActiveColor);

				&::before {
					content: '';
					height: 0;
					width: 0;
					background-color: var(--pendingActiveBackgroundColor);
					border-radius: 50%;
					position: absolute;
					top: -7px;
					right: -9px;
					z-index: 10;
				}
			}

			&:first-of-type {
				border-top-left-radius: var(--pillRadius);
				border-bottom-left-radius: var(--pillRadius);
				border-top-right-radius: 0;
				border-bottom-right-radius: 0;
			}

			&:last-of-type {
				border-top-right-radius: var(--pillRadius);
				border-bottom-right-radius: var(--pillRadius);
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
			}

			&.off {
				opacity: 0.4;

				&:hover {
					opacity: 1;
				}
			}
		}

		&.fixed-size {
			.btn-pill {
				width: 100%;
			}
		}
	}
</style>
